import { render, staticRenderFns } from "./PickupPointDetails.vue?vue&type=template&id=40d1d6b9&"
import script from "./PickupPointDetails.vue?vue&type=script&lang=js&"
export * from "./PickupPointDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports